<template>
  <b-modal ref="primeModal"
    no-close-on-backdrop
    no-close-on-esc
    centered
    body-class="prime-body"
    hide-header
    hide-footer>

    <div class="prime-container">
      <img src="/static/images/logo-prime.svg" class="prime-logo" alt="logo">

      <div class="prime-title" v-html="$t(benefitTitle)"></div>
      <div class="prime-section">
        <div v-if="isUnsupportText" class="unsupport-text"> {{ unsupportText }}</div>
        <div v-else class="benefit-items" v-for="(value, index) in benefitItems" :key="index">
          <img :src="value.icon" alt="icon" class="check-icon">
          <div class="benefit-text">
            {{ value.text }}
          </div>
        </div>
      </div>

      <div class="prime-btn-container">
        <button class="prime-ok-btn" type="button" @click="$emit('okModal')">{{ $t('prime.notice.confirm') }}</button>
        <button class="prime-close-btn" type="button" @click="$emit('closeModal')">{{ $t('prime.notice.cancel') }}</button>
      </div>
    </div>

  </b-modal>
</template>

<script>
  export default {
    name: 'prime-modal',

    props: {
      benefitTitle: {
        type: String,
        default: 'prime.benefit.title',
      },

      isUnsupportText: {
        type: Boolean,
        default: false,
      },
    },

    data() {
      return {
        benefitItems: [
          {
            icon: '/static/images/ic-check-benefit-copy.svg',
            text: this.$t('prime.benefit.item_1'),
          },
          {
            icon: '/static/images/ic-check-benefit-copy.svg',
            text: this.$t('prime.benefit.item_2'),
          },
          {
            icon: '/static/images/ic-check-benefit-copy.svg',
            text: this.$t('prime.benefit.item_3'),
          },
          {
            icon: '/static/images/ic-check-benefit-copy.svg',
            text: this.$t('prime.benefit.item_4'),
          },
        ],
        unsupportText: this.$t('prime.not_support'),
      };
    },

    mounted() {
      this.$refs.primeModal.show();
    },

  };
</script>

<style lang="scss">
  .prime-body {
    position: relative;
    background-image: linear-gradient(340deg, #4ed1ae, #229eec 60%, #6675e8);
    border: 0px;

    .prime-container {
      padding: 36px 24px 24px 24px;

      @media (max-width: 460px) {
        padding: 28px 14px 22px 14px;
      }

      .prime-background {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
      }

      .prime-logo {
        display: block;
        margin: 0 auto;
      }

      .unsupport-text {
        font-size: 14px;
        text-align: center;
        color: #ffffff;

        @media (max-width: 460px) {
          font-size: 12px;
        }
      }

      .prime-title {
        color: #ffffff;
        text-align: left;
        font-size: 24px;
        margin: 24px 40px 0px 40px;
        line-height: 1.33;

        @media (max-width: 460px) {
          font-size: 16px;
          margin: 24px 14px 0px 14px;
        }
      }

      .prime-section {
        margin: 36px 44px 64px 44px;

        @media (max-width: 460px) {
          margin: 28px 18px 34px 18px;
        }
      }

      .benefit-items {
        display: inline-block;

        .check-icon {
          vertical-align: text-bottom;
          margin-right: 4px;
        }

        .benefit-text {
          display: inline-block;
          text-align: left;
          font-size: 16px;
          color: #ffffff;
          margin-top: 14px;

          @media (max-width: 460px) {
            font-size: 14px;
          }
        }
      }

      .prime-image {
        margin-top: 24px;
        text-align: center;
      }

      .prime-btn-container {
        text-align: center;
        font-size: 18px;

        @media (max-width: 460px) {
          font-size: 14px;
        }

        .prime-ok-btn {
          background-color: #ffffff;
          border-radius: 3px;
          color: #005c87;
          border: 0;
          padding: 3% 22%;
          width: 100%;
          cursor: pointer;
          margin-bottom: 14px;
          display: block;
        }

        .prime-close-btn {
          background: none;
          color: #ffffff;
          border: 0;
          padding: 3% 22%;
          width: 100%;
          cursor: pointer;
          border-radius: 3px;
          display: block;
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// PrimeModal.vue?ac5d85d0